export default __webpack_public_path__ + "static/nasa-Q1p7bh3SHj8-unsplash-247c7b29fbf8721456b4de4a0b643423.jpg";